import React from 'react';
import LoadingSpinner from './loadingSpinner'
import {wsTrans} from '../utils/utils'
import {previewSubscription, createPlan, updateSubscription, updateIdoserTrialQty, getRecurlyAccount, getBilling, verifyBilling, addToAdminLog,
onCheckout, getZonesCount, getZoneDiscount, getIdoserPeriodPrice, hydrateIdoserQty, getTotal, loadZonesInfo, loadSitesInfo, getZoneInfo, getBalance, checkOwner, 
checkAdmin, loadUsersInfo, loadAccountInfo, redirectPrivs, loadGatewaysInfo, getGatewayInfo, getPearlType, getPearlCount,
isTrialPlanCode, getPlanPricing, isIdoserTrialActive, willStartIdoserTrial, getIdoserTrialDaysLeft, loadSubscriptionInfo, acctFeature} from './C18utils'
import {cl, globs, getTime,allStates,allTimezones, allZones, allAddons, capitalize, recurlySubdomain, round, zoneTypes, dateToYrMoDa, dateToMoDaYrStr, zoneQtyDiscount } from '../../components/utils/utils';
import C18Button00 from './C18Button00'
import C18Input00 from './C18Input00'
import C18MuiInput from './C18MuiInput';
import C18SiteZoneSub00 from './C18SiteZoneSub00'
import history from "../../history"
import UsaIcon from './UsaIcon';

class C18ManageSubscription extends React.Component{
  constructor(props) {
    super(props);
    this.state={
      loaded:false,
      preview:false,
      displayCheckout:false,
      displayPricingTable: false,
      opacity:1,
      fading:false,
      showPopup:true,
      auto_renew:true,
      changeTimeout:true,
      idoserChangeTimeout:true,
    }
    this.subscribe_savePageEvent=globs.events.subscribe("savePageEvent",this.saveZones)
    this.props.parms.onChange({cmd:"savePage", data:{savePage:true}})
    this.loadInfo()
    this.setBreadCrumbs()
  }
  
  setBreadCrumbs=()=>{
    if(this.props.parms){
      this.props.parms.onChange(
        {
          cmd: "breadcrumbs",
          data:
            {breadcrumbs: [
              {t:"Sites", url:"/usa/c18/sites"},
              {t:"Admin", url:`/usa/c18/admin`},
              {t:"Manage Subscription", url:`/usa/c18/admin/manageSubscription`},
            ]},
        },
      )
    }
  }

  loadInfo=async()=>{
    await loadUsersInfo()
    await loadAccountInfo()

    // redirect if not admin
    // redirectPrivs()

    await loadSitesInfo()
    await loadZonesInfo()
    await loadGatewaysInfo()
    await loadSubscriptionInfo()
    let sub = globs.subscriptionInfo.info
    if (!sub?.add_ons?.zone_qty) {
      let end_date = new Date()
      end_date.setDate(end_date.getDate() + 30)
      sub = {
        plan_code: "cloud2p0trialsub",
        plan_name: "Link4 Cloud Trial Subscription",
        add_ons: {zone_qty: {zone: {unlocked: 0, locked: 0}}, idoser_qty: 0, annual: false},
        auto_renew: true,
        end_date: end_date.toISOString(),
      }
      if (globs.subscriptionInfo) globs.subscriptionInfo.info = Object.assign({}, globs.subscriptionInfo.info || {}, sub)
    }
    // init/load selected_qty
    cl(sub)
    // this.mySetState(sub)
    // set zone_type to highest num of zones on acct
    let zone_type = "zone"
    // load recurly account
    let account = await getRecurlyAccount() || {}
    if(account.hasActiveSubscription){
      let now=getTime()// 20260318: Castle Valley, paid us by check, no billing info
      account.billingInfo={valid:true,expDate:now+30*86400,updatedAt:now}
    }
    let recurlyUrl = account.hostedLoginToken ?
      `https://${recurlySubdomain}.recurly.com/account/${account.hostedLoginToken}/` : ""
    this.saveZoneInfo(false)// save the names to compare later
    let siteSel=globs.sitesInfo.info?.[0]?.siteId
    let zoneSel=this.getZoneSel(siteSel)
    // load pricing table
    // let imagePath = "./link4_logo_blue_trans.png"
    // const img = new Image()
    // img.src = imagePath
    // // await img.decode()
    // img.onload = (() => {
    //   cl("loaded image")
    // })
    // get whether user is owner or admin
    let owner = checkOwner()
    let admin = await checkAdmin()

    // check if account is on "special" plan
    if (globs.accountInfo.info.customSubPrice) {
      this.customSubPrice = globs.accountInfo.info.customSubPrice
    }

    // calculate pearl protect count
    this.protect_count = getPearlCount("Protect")

    if (sub) {
      sub.protect_count = this.protect_count
      if (this.customSubPrice) sub.customSubPrice = this.customSubPrice
      hydrateIdoserQty(sub)
    }

    let vals = {zone_type: zone_type, loaded: true, oldPlan: sub, currPlan: sub ? JSON.parse(JSON.stringify(sub)) : sub,
      account: account, recurlyUrl: recurlyUrl, subChange: false, newConfig: [], zoneSel: zoneSel, owner: owner, admin: admin}
    if (vals.currPlan?.add_ons && vals.currPlan.add_ons.idoser_qty == null) {
      vals.currPlan.add_ons.idoser_qty = 0
    }
    if (vals.oldPlan?.add_ons && vals.oldPlan.add_ons.idoser_qty == null) {
      vals.oldPlan.add_ons.idoser_qty = 0
    }
    this.idoserQtyIntent = vals.currPlan?.add_ons?.idoser_qty || 0
    // after a cancel (zones saved as 0) the backend keeps the old iDoser count, so resubscribing brings it back
    if (!Number(vals.currPlan?.add_ons?.zone_qty?.zone?.[zoneTypes["unlocked"]] || 0)) {
      this.idoserQtyIntent = Math.max(this.idoserQtyIntent, parseInt(sub?.idoser_qty_prev) || 0)
    }
    // set period if not available
    this.mySetState(vals)
  }
  
  mySetState=(vals)=>{
    cl(vals)
    this.setState(vals)
  }

  saveZoneInfo=async(doSave)=>{// do Save, means save to db, not means copy current settings , newPlan means new plan will be created on recurly
    if(!doSave){
      this.zoneNames=[]
      this.zoneTiers=[]
      this.idoserTiers=[]
    }
    let gzi=globs.zonesInfo.info
    let adminAdds=[]
    let recurlyUpdate = false
    for(let i=0;i<gzi.length;i++){
      if(doSave){
        let zoneNew = {zoneId: gzi[i].zoneId}
        let zoneOld = {}
        let zoneChange = false
        if (this.zoneTiers[i]!=gzi[i].zoneTier){
          cl(`update ${gzi[i].zoneTier}`)
          zoneNew.zoneTier = gzi[i].zoneTier
          zoneOld.zoneTier = this.zoneTiers[i]
          zoneChange = true
          recurlyUpdate = true
        }
        if (this.idoserTiers[i]!=gzi[i].idoserTier){
          zoneNew.idoserTier = gzi[i].idoserTier
          zoneOld.idoserTier = this.idoserTiers[i]
          zoneChange = true
        }
        if (zoneChange) {
//           cl(zoneNew)
          this.saveZoneInfoToDb(zoneNew)
          this.saveToAdminLog(adminAdds, zoneOld, gzi[i])
        }
      }else{
        // identify zones as pearl protects here?
        this.zoneNames.push(gzi[i].zoneName)
        this.zoneTiers.push(gzi[i].zoneTier)
        this.idoserTiers.push(gzi[i].idoserTier)
      }
//       if(gzi[i].siteId==siteId){
//         return gzi[i].zoneId
//       }
    }
//     cl(adminAdds)
    if(doSave){addToAdminLog(adminAdds)}
  }

  saveZoneInfoToDb=async(data)=>{
    await wsTrans("usa", {cmd: "cRest", uri: "/s/zones", method: "update", 
      sessionId: globs.userData.session.sessionId, body: data})
    globs.events.publish("saveOK",true)
  }

  saveZones=async(cmd)=>{
    if(cmd=="save"){
      globs.events.publish("saveOK",true)
      // this.saveZoneNames(true)// save to db
      // make sure subscription transaction is made before saving zone info
      if (this.state.subChange) {
        if (this.isIdoserTrialOnlyChange()) {
          this.state.newConfig.forEach((z)=>{
            if (z.zoneTier != null) this.saveZoneTier(z.zoneId, z.zoneTier)
            if (z.idoserTier != null) this.saveIdoserTier(z.zoneId, z.idoserTier)
          })
          this.saveZoneInfo(true)
          let updated = await updateIdoserTrialQty(this.state.currPlan.add_ons)
          if (updated && globs.subscriptionInfo?.info) {
            Object.assign(globs.subscriptionInfo.info, updated)
            if (updated.add_ons) globs.subscriptionInfo.info.add_ons = updated.add_ons
            window.location.reload()
          }
          return
        }
        // make new plan
        this.state.currPlan.protect_count = this.protect_count
        if (this.customSubPrice) {
          this.state.currPlan.customSubPrice = this.customSubPrice
        }
        let planInfo = await onCheckout(this.state.currPlan)
        cl(planInfo)
        if (planInfo.plan) {
          planInfo.displayCheckout = true
          // get balance (to show credit available)
          let balance = await getBalance()
          cl(balance)
          planInfo.balance = balance
          this.mySetState(planInfo)
          // saving happens upon successful checkout
        } else {
          let title = `Error Processing Subscription Change`
          let text = `Unable to create the new subscription plan. Please try again.`
          await this.getPopup(title, text, ["OK"])
        }
      } else {
        // actually write zone tier
        this.state.newConfig.forEach((z)=>{
          if (z.zoneTier != null) this.saveZoneTier(z.zoneId, z.zoneTier)
          if (z.idoserTier != null) this.saveIdoserTier(z.zoneId, z.idoserTier)
        })
        this.saveZoneInfo(true)
      }
    }
//     history.goBack()
  }

  setZoneCount=(oldZoneTier, newZoneTier, revert=false)=>{// should not be changing zonesInfo!
      // do not decrement, and increment only if would be exceeding current license count
      let tiers = this.makeTiers()
      let oldZonesUnlocked = this.state.oldPlan.add_ons.zone_qty.zone[zoneTypes["unlocked"]] 
      let newZonesUnlocked = Object.keys(tiers).filter(k=>{return tiers[k]==zoneTypes["unlocked"]}).length
      cl([this.state.currPlan.add_ons.zone_qty.zone[newZoneTier]])
      // only subtract from licenses if switching to paid
      // if (newZoneTier == zoneTypes["unlocked"]) this.state.currPlan.add_ons.zone_qty.zone[oldZoneTier]--
      // always subtract from licenses even if locking
      // this.state.currPlan.add_ons.zone_qty.zone[oldZoneTier]--
      // only subtract from licenses if locking and license count is greater than old licenses
      if (newZoneTier == zoneTypes["locked"] && this.state.currPlan.add_ons.zone_qty.zone[zoneTypes["unlocked"]] > oldZonesUnlocked) {
        this.state.currPlan.add_ons.zone_qty.zone[oldZoneTier]--
      }
      // only add to unlocked zone count if the number of new zones is equal to new licenses
      // cl([this.state.currPlan.add_ons.zone_qty.zone[newZoneTier], newZonesUnlocked])
      if (newZoneTier != zoneTypes["unlocked"] ||  this.state.currPlan.add_ons.zone_qty.zone[newZoneTier] == (newZonesUnlocked - 1)) {
        this.state.currPlan.add_ons.zone_qty.zone[newZoneTier]++
      }
      cl([this.state.currPlan.add_ons.zone_qty.zone[zoneTypes["unlocked"]], newZonesUnlocked])
  }

  makeTiers=()=>{
    let tiers={}
    globs.zonesInfo.info.forEach(z=>{tiers[z.zoneId]=z.zoneTier})
    if(this.state.newConfig){
      this.state.newConfig.forEach(nc=>{
        if (nc.zoneTier != null) tiers[nc.zoneId]=nc.zoneTier
      })
    }
    return tiers
  }

  makeIdoserTiers=(stored=false)=>{
    let tiers={}
    globs.zonesInfo.info.forEach(z=>{tiers[z.zoneId]=z.idoserTier||zoneTypes["locked"]})
    if(this.state.newConfig){
      this.state.newConfig.forEach(nc=>{
        if (nc.idoserTier != null) tiers[nc.zoneId]=nc.idoserTier
      })
    }
    if (stored) return tiers
    // a zone locked outside this page can keep a stale idoserTier, which must not use up a license
    let statusTiers = this.makeTiers()
    Object.keys(tiers).forEach(k=>{
      if (statusTiers[k] != zoneTypes["unlocked"]) tiers[k]=zoneTypes["locked"]
    })
    return tiers
  }

  // merge tier changes for a zone into the pending (unsaved) config
  setNewConfig=(zoneId, fields)=>{
    let nc = this.state.newConfig.filter(z=>{return z.zoneId == zoneId})[0]
    if (nc) {
      Object.assign(nc, fields)
    } else {
      this.state.newConfig.push(Object.assign({zoneId: zoneId}, fields))
    }
  }

  // "A, B, C and 4 more" for popups
  zoneNameList=(zones)=>{
    let names = zones.slice(0, 5).map(z=>{return z.zoneName}).join(", ")
    return (zones.length > 5) ? `${names} and ${zones.length - 5} more` : names
  }

  getIdoserUnlockedCount=()=>{
    let tiers = this.makeIdoserTiers()
    return Object.keys(tiers).filter(k=>{return tiers[k]==zoneTypes["unlocked"]}).length
  }

  // unlocking a zone brings back its stored idoserTier, so lock it again if no iDoser license is free
  releaseStaleIdoserForZone=(zoneId)=>{
    let idoserTiers = this.makeIdoserTiers()
    if (idoserTiers[zoneId] != zoneTypes["unlocked"]) return
    if (this.getIdoserUnlockedCount() <= (this.state.currPlan.add_ons.idoser_qty || 0)) return
    let skip = false
    this.state.newConfig.forEach((z)=> {
      if (z.zoneId == zoneId) {
        z.idoserTier = zoneTypes["locked"]
        skip = true
      }
    })
    if (!skip) this.state.newConfig.push({zoneId: zoneId, idoserTier: zoneTypes["locked"]})
  }

  lockIdoserForZone=(zoneId)=>{
    let idoserTiers = this.makeIdoserTiers(true)
    if (idoserTiers[zoneId] != zoneTypes["unlocked"]) return
    let oldIdoserTier = zoneTypes["unlocked"]
    let idoserSkip = false
    this.state.newConfig.forEach((z)=> {
      if (z.zoneId == zoneId) {
        if (z.idoserTier != null) oldIdoserTier = z.idoserTier
        z.idoserTier = zoneTypes["locked"]
        idoserSkip = true
      }
    })
    if (!idoserSkip) this.state.newConfig.push({zoneId: zoneId, idoserTier: zoneTypes["locked"]})
    this.setIdoserCount(oldIdoserTier, zoneTypes["locked"])
  }

  // unlocking has to fit in the licenses bought; the count itself only changes through the counter
  isZoneLicenseFull=()=>{
    // trial accounts have no license count yet, so unlocking still adds licenses there
    if (isTrialPlanCode(this.state.currPlan?.plan_code || this.state.oldPlan?.plan_code)) return false
    let tiers = this.makeTiers()
    let used = Object.keys(tiers).filter(k=>{return tiers[k]==zoneTypes["unlocked"]}).length
    return used >= Number(this.state.currPlan.add_ons.zone_qty.zone[zoneTypes["unlocked"]] || 0)
  }

  getZoneLicenseCount=()=>{
    let zones = Number(this.state.currPlan?.add_ons?.zone_qty?.zone?.[zoneTypes["unlocked"]] || 0)
    if (zones > 0) return zones
    let planCode = this.state.currPlan?.plan_code || this.state.oldPlan?.plan_code
    if (isTrialPlanCode(planCode)) return Math.max((globs.zonesInfo?.info || []).length, 1)
    return 0
  }

  setIdoserCount=(oldIdoserTier, newIdoserTier)=>{
    let tiers = this.makeIdoserTiers()
    let oldQty = this.state.oldPlan.add_ons.idoser_qty || 0
    let newUnlocked = Object.keys(tiers).filter(k=>{return tiers[k]==zoneTypes["unlocked"]}).length
    let curQty = this.state.currPlan.add_ons.idoser_qty || 0
    if (newIdoserTier == zoneTypes["locked"] && curQty > oldQty) {
      this.setIdoserQty(curQty - 1)
    }
    if (newIdoserTier == zoneTypes["unlocked"] && curQty == (newUnlocked - 1)) {
      if (curQty + 1 > this.getZoneLicenseCount()) return
      this.setIdoserQty(curQty + 1)
    }
  }

  setIdoserQty=(qty)=>{
    this.state.currPlan.add_ons.idoser_qty = qty
    this.idoserQtyIntent = qty
  }

  getIdoserQtyIntent=()=>{
    // count the user asked for, which survives being capped by a lower zone license count
    return Math.max(this.idoserQtyIntent || 0, this.state.currPlan?.add_ons?.idoser_qty || 0)
  }

  // getZoneTier=(zoneId)=>{// should not be changing zonesInfo!
  //   let gzi=globs.zonesInfo.info
  //   for(let i=0;i<gzi.length;i++){
  //     if(gzi[i].zoneId==zoneId){
  //       return gzi[i].zoneTier
  //     }
  //   }
  // }

  getZoneSel=(siteId)=>{
    let gzi=globs.zonesInfo.info
    for(let i=0;i<gzi.length;i++){
      if(gzi[i].siteId==siteId){
        return gzi[i].zoneId
      }
    }
  }

  // only done iff plan is confirmed
  saveZoneTier=(zoneId,zoneTier)=>{// should not be changing zonesInfo!
    let gzi=globs.zonesInfo.info
    for(let i=0;i<gzi.length;i++){
      if(gzi[i].zoneId==zoneId){
        gzi[i].zoneTier=zoneTier
        return
      }
    }
  }

  saveIdoserTier=(zoneId,idoserTier)=>{
    let gzi=globs.zonesInfo.info
    for(let i=0;i<gzi.length;i++){
      if(gzi[i].zoneId==zoneId){
        gzi[i].idoserTier=idoserTier
        return
      }
    }
  }

  onCancel = () => {
    // TODO un-disable outside controls
    globs.events.publish("savePageEnable",true)
    this.mySetState({displayCheckout: false})
  }

  onConfirm = async () => {
    cl(JSON.stringify(this.state.newConfig))
    this.state.newConfig.forEach((z)=>{
      if (z.zoneTier != null) this.saveZoneTier(z.zoneId, z.zoneTier)
      if (z.idoserTier != null) this.saveIdoserTier(z.zoneId, z.idoserTier)
    })
    this.saveZoneInfo(true)
    // if billing info
    if (this.state.account?.billingInfo) {
    // if (true) {
      let verification = await verifyBilling()
      cl(verification)
      if (verification && verification.status == "success") {
        cl("proceeding with updating subscription")
        let updated = await updateSubscription(this.state.plan, this.state.currPlan.add_ons)
        // have to terminate and begin new subscription unless on trial?
        // refresh page
        // refund open credit invoices (do on backend)
        if (updated?.plan_code && !isTrialPlanCode(updated.plan_code)) {
          this.mySetState({displayCheckout: false, plan: null, preview: null, newConfig: [], subChange: false, currPlan: this.state.oldPlan})
          window.location.reload()
        } else {
          window.location.href = `https://${recurlySubdomain}.recurly.com/subscribe/${this.state.plan.code}/${this.state.account?.code}/${this.state.account?.username}`
        }
      } else {
        cl("verification failed")
        // popup telling user that their billing info needs to be changed + link
        let title = `Error Processing Subscription Change`
        let text = `The transaction failed because the stored payment method is no longer valid. Update your payment method and try again.`
        let buttons = ["Cancel", "Update Payment Method"]
        let res= await this.getPopup(title, text, buttons)
        if (res == "Update Payment Method") {
          window.open(this.state.recurlyUrl)
        } else {

        }
      }
    } else {
      // takes to recurly hosted payment page
      // will downgrade if confirmation was not made
      window.location.href = `https://${recurlySubdomain}.recurly.com/subscribe/${this.state.plan.code}/${this.state.account?.code}/${this.state.account?.username}`
      this.mySetState({displayCheckout: false, plan: null, preview: null, newConfig: [], subChange: false, currPlan: this.state.oldPlan})
    }
  }

  // onCheckout = async () => {
  //   // adjust plan to account for locked and disabled controllers on account
  //   // number of disabled controller should not change on this screen
  //   // number of locked controllers is total zones - (unlocked zones + disabled zones)
  //   let all_zones = globs.zonesInfo.info.length
  //   let locked_zones = all_zones - (this.state.currPlan.add_ons.zone_qty.zone[zoneTypes["unlocked"]])
  //   cl(globs.zonesInfo.info)
  //   cl([all_zones, locked_zones])
  //   this.state.currPlan.add_ons.zone_qty.zone[zoneTypes["locked"]] = locked_zones
  //   let planInfo = await onCheckout(this.state.currPlan)
  //   cl(planInfo)
  //   if (planInfo.plan && planInfo.preview) {
  //     planInfo.displayCheckout = true
  //     planInfo.plan.plan_code = planInfo.plan.code
  //     cl(planInfo.plan)
  //     // get balance (to show credit available)
  //     let balance = await getBalance()
  //     cl(balance)
  //     planInfo.balance = balance
  //     this.mySetState(planInfo)
  //     // saving happens upon successful checkout
  //   } else {
  //     // plan generation error
  //   }
  // }

  onChange=async(type,vals)=>{
    globs.events.publish("savePageEnable",true)
    switch(type){
      case "siteSel":
        Object.assign(vals,{zoneSel:this.getZoneSel(vals.siteSel)})
      case "zoneSel":
        this.mySetState(vals)
        break
      case "siteZone":
//         cl(vals)
        this.mySetState({zoneSel:vals.zoneId})
        break
      case "zoneTier":
//         cl(type,vals)
        // don't downgrade if switching to locked or disabled!
        // but how to handle case where going to unlocked
        let zoneInfo=getZoneInfo(vals.zoneSel)//this.state.zoneSel
        if (vals.zoneTier == zoneTypes["unlocked"] && this.isZoneLicenseFull()) {
          let licenses = this.state.currPlan.add_ons.zone_qty.zone[zoneTypes["unlocked"]]
          await this.getPopup(`All ${licenses} zone licenses are in use`,
            `Increase the license count on this page, or lock another zone, to unlock ${zoneInfo.zoneName}.`, ["OK"])
          break
        }
        let res = "Remove License"
        // skip confirm for 1s after an unlock so the same click can be undone
        if (vals.zoneTier == zoneTypes["unlocked"]) {
          this.state.changeTimeout = false
          clearTimeout(this.zoneChangeTimer)
          this.zoneChangeTimer = setTimeout(()=> {
            cl("timeout")
            this.state.changeTimeout = true
          }, 1000)
        }
        cl("changeTimeout: " + this.state.changeTimeout)
        let allTiers = this.makeTiers()
        let currentZoneTier = allTiers[vals.zoneSel] != null ? allTiers[vals.zoneSel] : zoneInfo.zoneTier
        if (vals.zoneTier == zoneTypes["locked"] && this.state.changeTimeout && currentZoneTier == zoneTypes["unlocked"]) {
          let title = `Remove license from ${zoneInfo.zoneName}?`
          let text = `Removing a license from a zone will not reduce the number of licenses you have allotted. License count can be adjusted on this page.`
          let buttons = ["Cancel", "Remove License"]
          res= await this.getPopup(title, text, buttons)
        }
        if (res=="Remove License") {
          // switching to locked
          // replace zone tier if zone already in newConfig
          let oldTier = zoneInfo.zoneTier
          let skip = false
          this.state.newConfig.forEach((z)=> {
            if (zoneInfo.zoneId == z.zoneId) {
              if (z.zoneTier != null) oldTier = z.zoneTier
              z.zoneTier = vals.zoneTier
              skip = true
              return
            }
          })
          if (!skip) this.state.newConfig.push({zoneId: zoneInfo.zoneId, zoneTier: vals.zoneTier})
          this.setZoneCount(oldTier, vals.zoneTier, skip)
          if (vals.zoneTier == zoneTypes["locked"]) this.lockIdoserForZone(zoneInfo.zoneId)
          if (vals.zoneTier == zoneTypes["unlocked"]) this.releaseStaleIdoserForZone(zoneInfo.zoneId)
        }
        break
      case "idoserTier":
        let idoserZone=getZoneInfo(vals.zoneSel)
        let statusTiers = this.makeTiers()
        let statusUnlocked = (statusTiers[vals.zoneSel] || idoserZone.zoneTier) == zoneTypes["unlocked"]
        if (vals.idoserTier == zoneTypes["unlocked"] && !statusUnlocked) break
        if (vals.idoserTier == zoneTypes["unlocked"]) {
          let idoserUnlockedNow = this.getIdoserUnlockedCount()
          let curIdoserQty = this.state.currPlan.add_ons.idoser_qty || 0
          if (idoserUnlockedNow >= curIdoserQty) {
            await this.getPopup(`All ${curIdoserQty} iDoser licenses are in use`,
              `Increase the iDoser license count on this page, or remove iDoser from another zone, to add it to ${idoserZone.zoneName}.`, ["OK"])
            break
          }
        }
        let idoserRes = "Remove License"
        if (vals.idoserTier == zoneTypes["unlocked"]) {
          this.state.idoserChangeTimeout = false
          clearTimeout(this.idoserChangeTimer)
          this.idoserChangeTimer = setTimeout(()=> {
            this.state.idoserChangeTimeout = true
          }, 1000)
        }
        let allIdoserTiers = this.makeIdoserTiers()
        let currentIdoserTier = allIdoserTiers[vals.zoneSel] != null ? allIdoserTiers[vals.zoneSel] : (idoserZone.idoserTier || zoneTypes["locked"])
        if (vals.idoserTier == zoneTypes["locked"] && this.state.idoserChangeTimeout && currentIdoserTier == zoneTypes["unlocked"]) {
          let title = `Remove iDoser license from ${idoserZone.zoneName}?`
          let text = `Removing an iDoser license from a zone will not reduce the number of iDoser licenses you have allotted. License count can be adjusted on this page.`
          let buttons = ["Cancel", "Remove License"]
          idoserRes= await this.getPopup(title, text, buttons)
        }
        if (idoserRes=="Remove License") {
          let oldIdoserTier = idoserZone.idoserTier || zoneTypes["locked"]
          let idoserSkip = false
          this.state.newConfig.forEach((z)=> {
            if (idoserZone.zoneId == z.zoneId) {
              if (z.idoserTier != null) oldIdoserTier = z.idoserTier
              z.idoserTier = vals.idoserTier
              idoserSkip = true
              return
            }
          })
          if (!idoserSkip) this.state.newConfig.push({zoneId: idoserZone.zoneId, idoserTier: vals.idoserTier})
          this.setIdoserCount(oldIdoserTier, vals.idoserTier)
        }
        break
      case "zone_qty":
        let copy_qty = this.state.currPlan.add_ons.zone_qty
        let tiers = this.makeTiers()
        let oldZonesUnlocked = this.state.oldPlan.add_ons.zone_qty.zone[zoneTypes["unlocked"]] 
        let newZonesUnlocked = Object.keys(tiers).filter(k=>{return tiers[k]==zoneTypes["unlocked"]}).length
        let newVal = parseInt(vals[2])
        if (isNaN(newVal)) break
        newVal = Math.max(0, Math.min(newVal, 999))
        if (newVal < newZonesUnlocked) {
          // going below the unlocked zones locks the extra ones (and their iDoser), after a confirm
          let lockZones = globs.zonesInfo.info.filter(z=>{return tiers[z.zoneId]==zoneTypes["unlocked"]}).slice(newVal)
          let lockRes = await this.getPopup(`Reduce to ${newVal} zone license${(newVal == 1) ? "" : "s"}?`,
            `${this.zoneNameList(lockZones)} will be locked, along with any iDoser on them. To choose different zones, cancel and lock those zones first.`,
            ["Cancel", "Lock Zones"])
          if (lockRes != "Lock Zones") break
          lockZones.forEach(z=>{this.setNewConfig(z.zoneId, {zoneTier: zoneTypes["locked"], idoserTier: zoneTypes["locked"]})})
          copy_qty[vals[0]][zoneTypes["locked"]] = (copy_qty[vals[0]][zoneTypes["locked"]] || 0) + lockZones.length
        }
        copy_qty[vals[0]][vals[1]] = newVal
        // iDoser count is only capped by the zone count, so it comes back if zones go back up
        this.state.currPlan.add_ons.idoser_qty = Math.min(this.getIdoserQtyIntent(), this.getZoneLicenseCount())
        break
      case "idoser_qty":
        let idoserVal = parseInt(vals)
        if (isNaN(idoserVal)) break
        let idoserUnlockedNow = this.getIdoserUnlockedCount()
        let curIdoser = this.state.currPlan.add_ons.idoser_qty || 0
        // an existing count above the zone cap can be kept or lowered, but not raised
        let maxIdoser = Math.min(999, Math.max(this.getZoneLicenseCount(), curIdoser))
        let idoserTarget = Math.max(0, Math.min(idoserVal, maxIdoser))
        if (idoserTarget < idoserUnlockedNow) {
          // going below the zones using iDoser takes it off the extra zones, after a confirm
          let idoserNow = this.makeIdoserTiers()
          let dropZones = globs.zonesInfo.info.filter(z=>{return idoserNow[z.zoneId]==zoneTypes["unlocked"]}).slice(idoserTarget)
          let dropRes = await this.getPopup(`Reduce to ${idoserTarget} iDoser license${(idoserTarget == 1) ? "" : "s"}?`,
            `iDoser will be removed from ${this.zoneNameList(dropZones)}. To choose different zones, cancel and turn off iDoser on those zones first.`,
            ["Cancel", "Remove iDoser"])
          if (dropRes != "Remove iDoser") break
          dropZones.forEach(z=>{this.setNewConfig(z.zoneId, {idoserTier: zoneTypes["locked"]})})
        }
        this.setIdoserQty(idoserTarget)
        break
      case "custom_fields":
        let copy_custom = this.state.currPlan.custom_fields
        copy_custom[vals[0]] = vals[1]
        break
      case "api_access":
        cl(vals)
        this.state.currPlan.add_ons.api_access = vals[type]
      case "annual":
        cl(vals)
        this.state.currPlan.add_ons.annual = vals[type]
      default:
        this.mySetState(vals)
        break
    }
    // check if plan changed
    let planChanged = this.isPlanChanged()
    this.mySetState({subChange: planChanged})

    // calculate new plan?
    // if (planChanged) {
    //   let planInfo = await onCheckout(this.state.currPlan)
    //   cl(planInfo)
    //   if (planInfo.plan && planInfo.preview) {
    //     // get balance (to show credit available)
    //     // let balance = await getBalance()
    //     // cl(balance)
    //     // planInfo.balance = balance
    //     this.mySetState(planInfo)
    //     // saving happens upon successful checkout
    //   } else {
    //     // plan generation error
    //   }
    // }
  }

  isPlanChanged = () => {
    // check add-ons
    let oldPeriod = this.state.oldPlan.add_ons.annual 
    let newPeriod = this.state.currPlan.add_ons.annual
    if (oldPeriod != newPeriod) return true
    let oldApi = this.state.oldPlan.add_ons.api_access 
    let newApi = this.state.currPlan.add_ons.api_access
    if (oldApi != newApi) return true
    // check unlocked count
    let oldZonesUnlocked = this.state.oldPlan.add_ons.zone_qty.zone[zoneTypes["unlocked"]] 
    let newZonesUnlocked = this.state.currPlan.add_ons.zone_qty.zone[zoneTypes["unlocked"]]
    if (newZonesUnlocked!=oldZonesUnlocked) return true
    let oldIdoser = this.state.oldPlan.add_ons.idoser_qty || 0
    let newIdoser = this.state.currPlan.add_ons.idoser_qty || 0
    if (newIdoser != oldIdoser) return true
    return false
  }

  isIdoserTrialOnlyChange = () => {
    let oldZonesUnlocked = Number(this.state.oldPlan?.add_ons?.zone_qty?.zone?.[zoneTypes["unlocked"]] || 0)
    let newZonesUnlocked = Number(this.state.currPlan?.add_ons?.zone_qty?.zone?.[zoneTypes["unlocked"]] || 0)
    if (oldZonesUnlocked != newZonesUnlocked) return false
    if (!!this.state.oldPlan?.add_ons?.annual != !!this.state.currPlan?.add_ons?.annual) return false
    if (!!this.state.oldPlan?.add_ons?.api_access != !!this.state.currPlan?.add_ons?.api_access) return false
    let oldIdoser = Number(this.state.oldPlan?.add_ons?.idoser_qty || 0)
    let newIdoser = Number(this.state.currPlan?.add_ons?.idoser_qty || 0)
    if (oldIdoser == newIdoser) return false
    let sub = globs.subscriptionInfo?.info
    return isIdoserTrialActive(sub) || willStartIdoserTrial(this.state.oldPlan, this.state.currPlan, sub)
  }

  showPricingTableButton = () => {
    return (
      <>
      <C18Button00 disabled={this.state.displayPricingTable} className="icon" onClick={e=>this.mySetState({displayPricingTable: !this.state.displayPricingTable})}>
        Pricing
      </C18Button00>
      <><div className="clearfloat"></div><br/></>
      </>
    )
  }

  showPricingTable = () => {
    let pricing = getPlanPricing(globs.subscriptionInfo?.info?.plan_code)
    let pZones = pricing.zones || allZones["zone"]
    let pDiscounts = pricing.discounts || zoneQtyDiscount
    let basePrice = pZones["unlocked"] || 0
    let disc1 = (pDiscounts["standard"] || [])[0] || 0
    let disc2 = (pDiscounts["standard"] || [])[1] || 0
    let annualBase = round(basePrice * 0.9)
    let annual11 = round((basePrice - disc1) * 0.9)
    let annual25 = round((basePrice - disc2) * 0.9)

    return(
      <>
        <div className="popup" style={{
          opacity: this.state.opacity,
          display:(this.state.displayPricingTable)?"block":"none"}}>
          <p>Pricing Table:</p>
          <div className="table-container">
            <table className="list pricing-table"><tbody>
              <tr key="pt1" >
                <td>Zone Count</td>
                <td>Monthly</td>
                <td>Monthly (*Billed Annually)</td>
              </tr>
              <tr key="pt2" >
                <td>1 to 10 Zones</td>
                <td>${basePrice}</td>
                <td>{annualBase}*</td>
              </tr>
              <tr key="pt3" >
                <td>11 to 24 Zones</td>
                <td>{round(basePrice - disc1)}</td>
                <td>{annual11}*</td>
              </tr>
              <tr key="pt4" >
                <td>25 or more Zones</td>
                <td>{round(basePrice - disc2)}</td>
                <td>{annual25}*</td>
              </tr>
            </tbody></table>
          </div>
          {this.isIdoserEnabled() &&
            <p className="colored-link-text-red">iDoser subscription is an additional $50/month billed<br/>monthly or $45/month billed annually.</p>
          }
          <div className="clearfloat"></div><br/>
          <div className="alignright">
          <C18Button00 className="icon" onClick={e=>this.mySetState({displayPricingTable: !this.state.displayPricingTable})}>
            Close
          </C18Button00>
          </div>
        </div>
        <div className="popup-scrim"></div>
      </>
    )
//     if (this.state.displayPricingTable) {

// //         cl(idsp)
// //         let im=await this.loadImage(path)
// //         cl(im)
// //         let im=this.getImage(path)
// //         cl(im)
//       cl(this.state.img)
//       let w=this.state.img.width
//       let h=this.state.img.height
//       if(w>500){
//         h=h*500/w
//         w=500
//       }

//       return (
//         <div key={0} style={{width: w, height: h}} className="image-popup"
//           >
//           <img width={w} src={this.state.img.src}
//           style={{backgroundColor: "#C0FFC0", borderRadius: 10, 
//             boxShadow: "5px 10px 10px #888888"}}
//           />
//           <div className="image-close-button">
//             <UsaIcon icon={`im0-Cancel`} result={o=>this.mySetState({displayPricingTable: !this.state.displayPricingTable})}/>
//           </div>
//         </div>
//       )  
//     }
  }

  saveToAdminLog=(adds,o,n)=>{
//     cl(o)
//     cl(n)
    let addObj={
      userId:globs.userData.session.userId,
      siteId:o.siteId,
      zoneId:o.zoneId,
      time:Math.floor(getTime())
    }
    if(o.zoneTier!=n.zoneTier){
      adds.push(
        Object.assign({},addObj,
        {
        action:"zoneTier",
        oldVal:o.zoneTier,
        newVal:n.zoneTier,
      }))
    }
    if(o.idoserTier!=n.idoserTier){
      adds.push(
        Object.assign({},addObj,
        {
        action:"idoserTier",
        oldVal:o.idoserTier,
        newVal:n.idoserTier,
      }))
    }
  }

  // show how much you will save/pay in comparison to old plan
  // use info from subscriptionChange preview (once it works)
  showDifference = () => {
    if (this.state.displayCheckout) {
      cl(this.state.preview?.invoice_collection)
      let msg = []
      let chargeBalance = 0
      if (!this.state.preview?.invoice_collection?.charge_invoice || !this.state.account?.billingInfo) {
        // get account balance to show next to charge today?
        // let oldTotal = (this.state.oldPlan.plan_code == "cloud2p0trialsub") ? 0 : getTotal(this.state.oldPlan)
        // cl(oldTotal)
        let newTotal = getTotal(this.state.currPlan)
        msg.push(<div key="charge">You will be charged {round(newTotal)} today.</div>)
      } else {
        let chargeTotal = this.state.preview.invoice_collection.charge_invoice.total
        let creditTotal = this.state.preview.invoice_collection.credit_invoices[0]?.total || 0
        chargeBalance = this.state.preview.invoice_collection.charge_invoice.balance
        let creditBalance = this.state.preview.invoice_collection.credit_invoices[0]?.balance || 0
        let planTotal = this.state.plan.currencies[0]?.unitAmount || 0
        cl([chargeTotal, creditTotal, chargeBalance, creditBalance, planTotal])
        // if (planTotal > 0) {
        //   // msg += `The total prorated charge is ${round(chargeTotal)}. The ${this.state.currPlan.custom_fields.Period} charge upon renewal will be ${round(planTotal)}. `
        //   msg.push(<div>The {this.state.currPlan.custom_fields.Period} charge upon renewal will be {round(planTotal)}.</div>)
        // }
        // if (creditTotal < 0) {
        //   // msg += `The total prorated credit from your previous subscription is ${round(Math.abs(creditTotal))}. `
        //   msg.push(<div>The total prorated credit from your previous subscription is {round(Math.abs(creditTotal))}. </div>)
        // }
        // if (creditBalance < 0) {
        //   // msg += `Your account will be credited ${round(creditBalance)} today.`
        //   msg.push(<div>You will be credited {round(Math.abs(creditBalance))} today.</div>)
        // }
        if (chargeBalance > 0) {
          // msg += `You will be charged ${round(chargeBalance)} today.`
          msg.push(<div key="charge">You will be charged a prorated amount of {round(chargeBalance)} today.</div>)
        } else {
          msg.push(<div key="charge">You will not be charged today.</div>)
        }
      }
      // cl(this.state.balance)
      if (this.state.account?.billingInfo && chargeBalance > 0 && this.state.balance?.balances[0]?.amount < 0 ) {
        msg.push(<div key="credit">Your account's credit balance of {round(Math.abs(this.state.balance?.balances[0]?.amount))} will be applied.</div>)
      }
      return (
        <div>
          {this.showPlanSummary(this.state.oldPlan, false, true)}
          {this.showPlanSummary(this.state.currPlan, true, true)}
          <div className="clearfloat"></div><br/>
          {msg}
        </div>
      )
    }
  }

  //   {title: ``,text:``,          
  // buttons:["Cancel","Lock zone"]}

  getPopup = (title, text, buttons) => {
    return new Promise((r, e)=> {
      let popup = {
        title: title,
        text: text,
        buttons: buttons,
        displayPopup: true,
        r: r
      }
      this.setState({popup:popup})
    })
  }

  resolvePopup = (b) => {
    cl(b)
    this.state.popup.r(b)
    let popup = this.state.popup
    popup.displayPopup = false
    this.setState({popup: popup})
  }

  showPopup = () => {
    // let diff=this.props.parms.opacity-this.state.opacity
    // if(diff){setTimeout(this.doFading,1)}
    if (this.state.popup) {
      return (
        <>
          <div className="popup" style={{
            display:(this.state.popup.displayPopup)?"block":"none"}}>
            <p><b>{this.state.popup.title}</b></p>
            <br />
            <p><i>*{this.state.popup.text}</i></p>
            <div className="alignright">
            <br/>
            {this.state.popup.buttons.map((b, i)=> {
              return (
                <>
                <C18Button00 className="icon" key={i} onClick={e=>this.resolvePopup(b)}>
                {b}
                </C18Button00>
                <div className="divider"/>
                </>
              )
            })}
            <div className="clearfloat"></div><br/>
            </div>
          </div>
          <div className="popup-scrim"></div>
        </>
      )
    }
  }

  // pop up comparison screen
  showCheckout = () => {
    // let diff=this.props.parms.opacity-this.state.opacity
    // if(diff){setTimeout(this.doFading,1)}
    return(
      <>
        <div className="popup" style={{
          opacity: this.state.opacity,
          display:(this.state.displayCheckout)?"block":"none"}}>
          <p>Order Summary:</p>
          <br />
          <div className="alignright">
          {this.showDifference()}
          <br/>
          <C18Button00 className="icon" onClick={e=>this.onCancel()}>
            Cancel
          </C18Button00>
          <div className="divider"/>
          <C18Button00 className="icon" onClick={e=>this.onConfirm()}>
            Place your order
          </C18Button00>
          <div className="clearfloat"></div><br/>
          </div>
        </div>
        <div className="popup-scrim"></div>
      </>
    )
  }


  showPlanSummary = (plan, newPlan = false, checkout = false) => {
    cl("show plan summary")
    let pricing = getPlanPricing(globs.subscriptionInfo?.info?.plan_code)
    let pZones = pricing.zones ? {"zone": pricing.zones} : allZones
    let zone_total = 0
    let annual = (plan.add_ons.annual) ? 12 : 1
    let annual_discount = (plan.add_ons.annual) ? .9 : 1
    // let chargeTotal = null
    // let creditSub = null
    let chargeBalance = null
    // let creditBalance = null
    // let creditTotal = 0
    // let planTotal 
    // count protects

    plan.protect_count = this.protect_count
    if (this.customSubPrice) {
      plan.customSubPrice = this.customSubPrice
    }
    if (!newPlan) hydrateIdoserQty(plan)
    let real_total = getTotal(plan)
    let idoserInfo = getIdoserPeriodPrice(plan)
    let oldZonesUnlocked = Number(this.state.oldPlan?.add_ons?.zone_qty?.zone?.[zoneTypes["unlocked"]] || 0)
    let newZonesUnlocked = Number(this.state.currPlan?.add_ons?.zone_qty?.zone?.[zoneTypes["unlocked"]] || 0)
    let zonesChanged = this.state.oldPlan ? oldZonesUnlocked != newZonesUnlocked : newZonesUnlocked > 0
    let oldIdoserQty = Number(this.state.oldPlan?.add_ons?.idoser_qty || 0)
    let newIdoserQty = Number(this.state.currPlan?.add_ons?.idoser_qty || 0)
    let idoserChanged = oldIdoserQty != newIdoserQty
    let periodChanged = this.state.oldPlan && this.state.oldPlan.add_ons.annual != this.state.currPlan.add_ons.annual
    let showZoneLine, showIdoserLine
    if (checkout) {
      showZoneLine = zonesChanged || (periodChanged && !idoserChanged && (newPlan ? newZonesUnlocked : oldZonesUnlocked) > 0)
      showIdoserLine = idoserChanged ? (newPlan || oldIdoserQty > 0) : (periodChanged && idoserInfo.qty > 0)
    } else {
      showZoneLine = !newPlan || zonesChanged
      showIdoserLine = newPlan ? idoserChanged : idoserInfo.qty > 0
    }
    // cl(real_total)
    if (this.state.preview?.invoice_collection?.charge_invoice) {
    //   chargeTotal = this.state.preview.invoice_collection.charge_invoice.total
    //   creditSub = this.state.preview.invoice_collection.credit_invoices[0]?.total || 0
      chargeBalance = this.state.preview.invoice_collection.charge_invoice.balance
    //   creditBalance = this.state.preview.invoice_collection.credit_invoices[0]?.balance || 0
    //   planTotal = this.state.plan.currencies[0]?.unitAmount || 0
    //   this.state.preview.invoice_collection.charge_invoice.credit_payments.forEach((payment)=>{
    //     creditTotal += payment.amount
    //   })
    //   cl([chargeTotal, creditSub, chargeBalance, creditBalance, planTotal, creditTotal])
    // use getTotal to calculate final amount
    }
    return (
      <div className="table-container">
        <table className="list subscription">
        <tbody>
        {(!newPlan && isTrialPlanCode(plan.plan_code)) ? 
          <tr key="trial" className="checkout-summary-row">
            <td>Trial</td>
            <td></td>
            <td>=</td>
            <td>{round(0)}</td>
          </tr>
        :
          showZoneLine && Object.entries(pZones).map(([type, price])=>{
            let qtys = plan.add_ons.zone_qty[type]
            return Object.entries(qtys).map(([tier, val]) => {
              if (tier == zoneTypes["unlocked"]) {
                // if on special plan, calculate plan by total assigned price
                if (plan.customSubPrice) {
                  zone_total += (val * (plan.customSubPrice.price / plan.customSubPrice.count))
                } else {
                  // reduce protect_count by 1 and use protect pricing
                  if (plan.protect_count > 0) {
                    let protect_total = (price["unlocked_protect"] - getZoneDiscount(plan, "protect")) * plan.protect_count * annual * annual_discount
                    zone_total += protect_total
                    // cl([price["unlocked_protect"], getZoneDiscount(plan, "protect"), plan.protect_count, protect_total])
                  }
                  let t_total = (price[tier] - getZoneDiscount(plan)) * (val - plan.protect_count)  * annual * annual_discount
                  // cl([price[tier], getZoneDiscount(plan), (val - plan.protect_count), t_total])
                  zone_total += t_total
                }
                if (val > 0) {
                  return (
                    <tr key={type + tier} className="checkout-summary-row">
                      <td>{(checkout) ? 
                        (newPlan) ? `New Subscription` : `Current Subscription`
                        :
                        `${(plan.add_ons.annual) ? "Annual" : "Monthly"} ${capitalize(type)} License`
                        }
                      </td>
                      {this.customSubPrice ? 
                      <>
                      <td>{val} x {round(plan.customSubPrice.price / plan.customSubPrice.count)}</td>
                      </>
                      :
                      <>
                      <td>{val - plan.protect_count} x {round((price[tier] - getZoneDiscount(plan)) * annual * annual_discount)} (Standard)</td>
                      {plan.protect_count > 0 && <td>+</td>}
                      {plan.protect_count > 0 && <td>{plan.protect_count} x {round((price["unlocked_protect"] - getZoneDiscount(plan, "protect")) * annual * annual_discount)} (Protect)</td>}
                      </>
                      }
                      <td>=</td>
                      <td>{round(showIdoserLine ? zone_total : real_total)}</td>
                    </tr>
                  )
                }
              }
            })
          })
        }
        {showIdoserLine &&
          <tr key="idoser" className="checkout-summary-row">
            <td>{idoserInfo.trial ?
              (idoserInfo.trialEndsAt ?
                `iDoser trial (ends ${dateToMoDaYrStr(new Date(idoserInfo.trialEndsAt))})` :
                "iDoser trial")
              : checkout ?
              (newPlan ? "New iDoser License" : "Current iDoser License")
              :
              `${(plan.add_ons.annual) ? "Annual" : "Monthly"} iDoser License`
            }</td>
            <td>{idoserInfo.qty} x {round(idoserInfo.unit)}</td>
            <td>=</td>
            <td>{round(idoserInfo.total)}</td>
          </tr>
        }
        {Object.entries(allAddons).map(([type, price])=> {
          // if (type == "API Access" && state.add_ons.api_access) {
          //   total += price * annual
          //   return (
          //     <tr>
          //       <td>{capitalize(type)} </td>
          //       <td>1 x ${price * annual}</td>
          //       <td>=</td>
          //       <td>{round(price * annual)}</td>
          //     </tr>
          //   )
          // }
        })
        }
        </tbody>
        </table>
      </div>      
    )
  }

  // {newPlan && 
  // <tr>
  //   <td>Prorated Credit</td>
  //   <td></td>
  //   <td>=</td>
  //   <td>{(creditSub != null) ? `-${round(Math.abs(creditSub))}` : "*calculated at checkout*"}</td>
  // </tr>
  // }

  showRecurlyButton = () => {
    // check if current user is owner
    // let owner = globs.accountInfo.info.owner==globs?.userData?.session?.userId
    cl(this.state.account)
    if (this.state.recurlyUrl) {
      return (
        <>
        <C18Button00 disabled={!this.state.owner} className="outlined">
          {
            (this.state.owner) ?
            <a target="_blank" rel="noopener noreferrer" href={this.state.recurlyUrl} className="colored-link-text">
              Billing & Invoices
            </a> 
            :
            <a style={{color: "#aaa"}}>
              Billing & Invoices
            </a>
          }
        </C18Button00>
        <><div className="clearfloat"></div><br/></>
        {!this.state.account?.billingInfo &&
          <div style={{display: "flex"}}>
            <div className="subscription-alarm-number">!</div>
            <div className="colored-link-text-red">   No billing information detected. {!this.state.owner ? "Please contact your owner to configure this setting." : ""}</div>
          </div>
        }
        <br/>
        {this.state.account?.hasPastDueInvoice &&
          <div style={{display: "flex"}}>
            <div className="subscription-alarm-number">!</div>
            <div className="colored-link-text-red">   This account is past due. {!this.state.owner ? "Please contact your owner to restore account status." : ""}</div>
          </div>
        } 
        <><div className="clearfloat"></div><br/></>
        </>
      )
    }
  }

  showPlanCheckout = () => {
    // let total_count_arr = Object.entries(allZones).map(([type, price]) => getZonesCount(type, this.state, true)) 
    // cl(total_count_arr)
    // let total_count = total_count_arr.reduce((val1, val2) => val1 + val2) 
    // disable checkout if plan config is the same,  show mouseover text
    return (
      <>
      <C18Button00 className="outlined" onClick={e=>this.onCheckout()}>
        Checkout
      </C18Button00>
      <><div className="clearfloat"></div><br/></>
      </>
    )
  }

  showIdoserTrialBanner = () => {
    let sub = globs.subscriptionInfo?.info
    if (!this.isIdoserEnabled() || !isIdoserTrialActive(sub)) return null
    let days = getIdoserTrialDaysLeft(sub)
    let ends = dateToMoDaYrStr(new Date(sub.idoser_trial_ends_at))
    return (
      <p>iDoser trial, {days} day{days === 1 ? "" : "s"} left (ends {ends}). No iDoser charge during the trial.</p>
    )
  }

  showCurrentPlan = () => {
    // show details of current plan
    // all accounts should be initialized to "free trial" - zones should still be counted but free trial discount will show
    // being on trial means that all zone and feature limits are bypassed
    if (!this.state.oldPlan) return null
    let dateStr = (isTrialPlanCode(this.state.oldPlan.plan_code) || !this.state.oldPlan.auto_renew) ? "Ends on " : "Renews on "
    let dateFmt = dateToMoDaYrStr(new Date(this.state.oldPlan.end_date))
    return (
      <div>
        <h2>Current Subscription ({dateStr} <span className="colored-link-text-red">{dateFmt}</span>)</h2>
        {this.showIdoserTrialBanner()}
        {this.showPlanSummary(this.state.oldPlan)}
      </div>
    )
  }

  showPlanPreview = () => {
    // show "cart"-like summary of their choices
    // show "proceed to checkout"  button (will show preview of old -> new plan and cost total)
    if (this.state.subChange) {
      return (
        <div>
        <h2>New Subscription Preview</h2>
        {this.showPlanSummary(this.state.currPlan, true)}
        </div>
      )
    }
  }

  showZoneTypeSelect = () => {
    let arr = Object.entries(allZones);
    return (
      <div>
      <label htmlFor="zone-type">Zone Type</label>
        <span className="custom-select">
          <select id="zone-type"
            value={capitalize(this.state.zone_type)}
            onChange={(e)=>this.onChange("zone_type", {zone_type: e.currentTarget.value})}
          >
          {Object.entries(allZones).map(([type, val])=>{
            return(
              <option key={type} value={type}>{capitalize(type)}</option>
            )
          })}
          </select>
          <span className="material-icons down-arrow">
            keyboard_arrow_down
          </span>
        </span>
      </div>
    )
  }

  showPeriodSelect = () => {
    return (
      <div className="slide-switch">
        <label className="switch-label" htmlFor="period-monthly">Monthly</label>
        <label className="switch">
          <C18Input00
            type="checkbox"
            id="period-toggle"
            name="period-toggle"
            checked={this.state.currPlan.add_ons.annual}
            onChange={e=>this.onChange("annual", {annual: !this.state.currPlan.add_ons.annual})}
          />
          <span className="slider round"></span>
        </label>
        <label className="switch-label" htmlFor="period-annual">Annual</label>
        <><div className="clearfloat"></div><br/></>
      </div>
    )
  }

  showApiSelect = () => {
    return (
      <div className="slide-switch">
        <label className="switch">
          <C18Input00
            type="checkbox"
            id="api-toggle"
            name="api-toggle"
            checked={this.state.currPlan.add_ons.api_access}
            onChange={e=>this.onChange("api_access", {api_access: !this.state.currPlan.add_ons.api_access})}
          />
          <span className="slider round"></span>
        </label>
        <label className="switch-label" htmlFor="api-access">API Access</label>
        <><div className="clearfloat"></div><br/></>
      </div>
    )
  }

  // <C18Input00 type="radio" id="period-annual" name="periodselect" value="annual"
  //         checked={this.state.custom_fields.Period=="annual"}
  //         onChange={e=>this.onChange("period", {period: e.target.value})}
  //       ></C18Input00>

  //     <C18Input00 type="radio" id="period-monthly" name="periodselect" value="monthly"
  //       checked={this.state.custom_fields.Period=="monthly"}
  //       onChange={e=>this.onChange("period", {period: e.target.value})}
  //     ></C18Input00>

  showTiers = () => {
    // show each tier and how many zones they have selected for the selected zone type
    // for each tier (under selected zone type)
    let qtys = this.state.currPlan.add_ons.zone_qty[this.state.zone_type]
    return (
      <div>
      {
        // make tier header
        // make tier quantity select
        // show tier features can be adjusted based on the selected zone type
        Object.entries(qtys).map(([tier, val]) => {
          if (tier == zoneTypes["unlocked"]) {
            return (
              <div key={this.state.zone_type + tier}>
                <h2>{capitalize(tier)}</h2>
                <C18MuiInput
                  key={this.state.zone_type + tier}
                  value={val}
                  onChange={(e) => this.onChange("zone_qty", [this.state.zone_type, tier, e.currentTarget.value])}
                  type="number"
                  saveOK={true}
                  unit="zones"
                  inputProps={{
                      step: 1,
                      min: 0,
                      max: 999,
                      inputMode:"decimal",
                      type:"number",
                      style: {textAlign: 'center'}
                  }}
                />
              </div>
            )
          }
        })
      }
      </div>
    )
      

  }

  showPlanTable = () => {
    // show select controls for adjusting plan (plan should already prefill the current categories)
    // show select drop-down (default is zone they have most add-ons for)
    // selecting a different zone type adjusts the price (and features?) of the zones shown in the table
    return (
      <div>
      {this.showPeriodSelect()}
      </div>
    ) 
    // {this.showApiSelect()}
    // <h2>{capitalize(this.state.zone_type)} Select</h2>
    // {this.showZoneTypeSelect()}
  }


  // iDoser subscription is behind the account's "idoser" feature flag (Tech Portal), but an account
  // that already pays for iDoser keeps seeing it so the charge can still be viewed and removed
  isIdoserEnabled = () => {
    return acctFeature("idoser") || Number(this.state.oldPlan?.add_ons?.idoser_qty || 0) > 0
  }

  canShowIdoserPurchase = () => {
    return this.isIdoserEnabled() && this.getZoneLicenseCount() > 0
  }

  showManageSubscription = () => {
    if (!this.state.currPlan?.add_ons?.zone_qty?.zone) {
      return (
        <div>
          <p>Unable to load subscription details for this account. Refresh the page or try again in a moment.</p>
        </div>
      )
    }
    let showIdoserPurchase = this.canShowIdoserPurchase()
    return (
      <div>
      {this.showCurrentPlan()}
      {this.showPlanPreview()}
      <><div className="clearfloat"></div><br/></>
      {this.showPlanTable()}
      {this.showCheckout()}
      {this.showPopup()}
      {this.showRecurlyButton()}
      {this.showPricingTableButton()}
      {this.showPricingTable()}
      <C18SiteZoneSub00 parms={{
        edit:false,
        height:200,
        value:this.state.zoneSel,
        onChange:this.onChange,
        newConfig:this.state.newConfig,
        zoneNames:this.zoneNames,
        totalLicenses:this.state.currPlan.add_ons.zone_qty.zone[zoneTypes["unlocked"]],
        totalIdoserLicenses:showIdoserPurchase ? (this.state.currPlan.add_ons.idoser_qty || 0) : null,
        disabled:false
      }}/>
      </div>
    )
  }
  

  render(){
    if(this.state.loaded){
      return this.showManageSubscription()
    } else{
      return <LoadingSpinner message="Loading..." />
    }
  }
}
      
export default C18ManageSubscription;
